<div>
  @if (to.label) {
    <p>
      {{ to.label | translate }}
    </p>
  }
  <div class="ms-3">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
